module.exports = __webpack_public_path__ + "files/3b063c6a3781056f4deee629f7e48830.png";